export const VrboIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35">
  <rect width="35" height="35" rx="6" fill="#0e214b"/>
  <g transform="translate(3, 3) scale(1.15)">
    <path d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6Z" fill="#0E214B"/>
    <path d="m14.76 10.79.04.02c.96-3.17 1.27-4.57.42-5.42h-1.2v.03c1.34.47 1.64 1.83.74 5.37Z" fill="#8EC089"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M18.57 5.39c-1.28.74-2.04 2.12-3.65 5.5l.04.03c1.85-3.43 2.9-4.8 5.28-5.5v-.03h-1.67Z" fill="#2474DE"/>
    <path d="m14.84 10.84.04.03c1.51-3.56 1.91-4.53 2.53-5.45v-.03h-1.23v.04c.13 1.41-.36 2.72-1.34 5.41Z" fill="#E85F24"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.75 5.39H3.66v.03c1 .38 1.48 1.13 1.87 2.88L8.2 20.55h.61L6.12 8.2C5.66 6.1 5.17 5.7 4.75 5.4Z" fill="#76C5F7"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="m10.44 19.7.4-.84L8.58 8.29c-.4-1.64-.3-2.39-.14-2.9h-.87a9.4 9.4 0 0 0 .34 2.63l2.53 11.67Z" fill="#2474DE"/>
    <path d="M6.78 5.39H5.76v.03c.46.54.59 1.2.95 2.67l2.71 12.46h.61L7.31 8.05c-.38-1.6-.45-2.04-.53-2.66Z" fill="#318EEE"/>
    <path d="m11.25 18.01.4-.84-1.8-8.69c-.35-1.69-.2-2.56.36-3.06v-.03h-.96c-.3.63-.4 1.26-.05 2.93l2.05 9.7Z" fill="#E85F24"/>
    <path d="M10.49 8.54c-.5-2.33.38-2.95.8-3.15h1.43v.03c-1.55.3-2 1.15-1.63 3.1l1.38 6.96-.4.85-1.58-7.8Z" fill="#8EC089"/>
  </g>
</svg>

);
